"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Table = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _utils = require("./utils");
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ASCENDING = 'asc';
const DESCENDNG = 'desc';
const Table = props => {
  const {
    initialData,
    columns,
    rowTemplate: RowTemplate,
    pagination = {},
    a11yOptions
  } = props;
  const classes = (0, _styles.default)();
  const {
    keyName = 'id'
  } = initialData;
  const {
    checkbox = {}
  } = columns;
  const {
    onChangeCallback = () => null
  } = checkbox;
  const {
    show: showPagination = true,
    callback: pageAndRowCallback = () => null
  } = pagination;
  const hasCheckbox = columns?.checkbox?.show ?? false;
  const [computedHeaders, setComputedHeaders] = (0, _react.useState)(() => (0, _utils.computeHeaderWidth)(columns?.headers, hasCheckbox));
  const [tableData, setTableData] = (0, _react.useState)(initialData?.data ?? []);
  const [checkedRows, setCheckedRows] = (0, _react.useState)([]);
  const [tableMetadata, setTableMetadata] = (0, _react.useState)({
    rowsPerPage: (0, _utils.getStoredPerPageValue)(),
    page: 0,
    count: initialData?.count ?? initialData?.data.length,
    sortingBy: null,
    sortingDirection: null
  });
  const hasCheckedAllItem = () => {
    const hasUncheckedRows = tableData.some(item => !checkedRows.includes(item?.[keyName]));
    return !hasUncheckedRows;
  };
  const isItemChecked = item => {
    return checkedRows.includes(item?.[keyName]);
  };
  const handleCheckallEvent = evt => {
    const nextState = evt.target.checked ? tableData.map(ea => ea[keyName]) : [];
    setCheckedRows(nextState);
    setImmediate(() => onChangeCallback(nextState, tableData));
  };
  const handleSingleItemCheckEvent = (evt, item) => {
    let nextState = [];
    if (!evt.target.checked) {
      nextState = checkedRows.filter(ea => ea !== item?.[keyName]);
    } else {
      nextState = [...checkedRows, item?.[keyName]];
    }
    setCheckedRows(nextState);
    setImmediate(() => onChangeCallback(nextState, tableData));
  };
  const rowsPerPageChangeHandler = evt => {
    const newPerPageValue = evt.target.value;
    const newTableMetaData = {
      ...tableMetadata,
      rowsPerPage: newPerPageValue
    };
    setTableMetadata(newTableMetaData);
    (0, _utils.setStoredPerPageValue)(newPerPageValue);
    const {
      count,
      page,
      rowsPerPage
    } = newTableMetaData;
    setImmediate(() => pageAndRowCallback({
      count,
      page,
      rowsPerPage
    }));
  };
  const paginationPageChangeHandler = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    // eslint-disable-next-line no-unused-vars
    const [_, page] = args;
    setTableMetadata(prev => ({
      ...prev,
      page
    }));
  };
  const headerSortingClickHandler = columnId => {
    if (tableMetadata.sortingBy === columnId) {
      setTableMetadata(prev => ({
        ...prev,
        sortingDirection: prev.sortingDirection === ASCENDING ? DESCENDNG : ASCENDING
      }));
      return;
    }
    setTableMetadata(prev => ({
      ...prev,
      sortingBy: columnId,
      sortingDirection: ASCENDING
    }));
  };
  const sortingFn = () => {
    if (!tableMetadata.sortingBy || !tableMetadata.sortingDirection) {
      return () => -1;
    }
    const columnCustomSortingFn = computedHeaders.find(ea => ea?.[keyName] === tableMetadata.sortingBy)?.comparatorFn ?? {};
    const {
      asc,
      desc
    } = {
      asc: (a, b) => {
        if (!a?.[tableMetadata.sortingBy]) return 1;
        return a?.[tableMetadata.sortingBy] > b?.[tableMetadata.sortingBy] ? 1 : -1;
      },
      desc: (a, b) => {
        if (!a?.[tableMetadata.sortingBy]) return 1;
        return a?.[tableMetadata.sortingBy] > b?.[tableMetadata.sortingBy] ? -1 : 1;
      },
      ...columnCustomSortingFn
    };
    return tableMetadata.sortingDirection === ASCENDING ? asc : desc;
  };
  const computedPageData = () => {
    const {
      page,
      rowsPerPage
    } = tableMetadata;
    const start = page * rowsPerPage;
    const end = page * rowsPerPage + rowsPerPage;
    return tableData.sort(sortingFn()).slice(start, end);
  };
  const computeSortDirectionForHeadeer = computedHeaderId => {
    if (tableMetadata.sortingBy === computedHeaderId) {
      return tableMetadata.sortingDirection;
    }
    return undefined;
  };
  const rowAriaLabel = (0, _react.useCallback)(item => a11yOptions?.checkSingleItemLabel(item) ?? 'Checkbox da linha', [a11yOptions?.checkSingleItemLabel]);
  (0, _react.useEffect)(() => {
    setComputedHeaders((0, _utils.computeHeaderWidth)(columns?.headers, hasCheckbox));
  }, [columns?.headers]);
  (0, _react.useEffect)(() => {
    setTableData(initialData?.data ?? []);
    setTableMetadata({
      rowsPerPage: (0, _utils.getStoredPerPageValue)(),
      page: 0,
      count: initialData?.count ?? initialData?.data.length,
      sortingBy: null,
      sortingDirection: null
    });
    setCheckedRows([]);
  }, [initialData?.data]);
  return /*#__PURE__*/_react.default.createElement(_core.TableContainer, {
    component: _core.Paper
  }, /*#__PURE__*/_react.default.createElement(_core.Table, {
    className: classes.table
  }, /*#__PURE__*/_react.default.createElement("caption", null, a11yOptions?.tableCaption), /*#__PURE__*/_react.default.createElement(_core.TableHead, null, /*#__PURE__*/_react.default.createElement(_core.TableRow, null, hasCheckbox && /*#__PURE__*/_react.default.createElement(_core.TableCell, {
    style: {
      width: 56
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
    style: {
      padding: 0
    },
    checked: hasCheckedAllItem(),
    disableRipple: true,
    color: "primary",
    onChange: handleCheckallEvent,
    inputProps: {
      'aria-label': a11yOptions?.checkAllLabel
    }
  })), computedHeaders.map(header => /*#__PURE__*/_react.default.createElement(_core.TableCell, {
    key: header?.[keyName],
    style: {
      width: header.computedWidth
    },
    scope: "col",
    align: header?.headerAlign ?? 'left'
  }, header?.allowSorting ? /*#__PURE__*/_react.default.createElement(_core.TableSortLabel, {
    active: tableMetadata.sortingBy === header?.id,
    direction: computeSortDirectionForHeadeer(header?.id),
    onClick: () => headerSortingClickHandler(header?.id)
  }, header?.label, tableMetadata.sortingBy === header?.label ? /*#__PURE__*/_react.default.createElement("span", {
    className: classes.visuallyHidden
  }, tableMetadata.sortingDirection === DESCENDNG ? 'ordenado de forma descrescente' : 'ordenado de forma ascendente') : null) : header?.label)))), /*#__PURE__*/_react.default.createElement(_core.TableBody, null, computedPageData()?.map((item, index) => RowTemplate ? /*#__PURE__*/_react.default.createElement(RowTemplate, {
    item: item,
    key: item?.[keyName] ?? index,
    showCheckbox: hasCheckbox,
    isChecked: isItemChecked(item),
    onCheck: handleSingleItemCheckEvent
  }) : /*#__PURE__*/_react.default.createElement(_core.TableRow, {
    key: item?.[keyName] ?? index
  }, hasCheckbox && /*#__PURE__*/_react.default.createElement(_core.TableCell, {
    style: {
      padding: '0 16px'
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
    style: {
      padding: 0
    },
    checked: isItemChecked(item),
    disableRipple: true,
    color: "primary",
    onChange: evt => handleSingleItemCheckEvent(evt, item),
    inputProps: {
      'aria-label': rowAriaLabel(item)
    }
  })), computedHeaders?.map((column, colIndex) => {
    return /*#__PURE__*/_react.default.createElement(_core.TableCell
    // eslint-disable-next-line react/no-array-index-key
    , {
      key: colIndex,
      align: column?.bodyAlign ?? 'left'
    }, column?.cellAction?.callback ? /*#__PURE__*/_react.default.createElement(_core.Button, {
      "aria-label": column?.cellAction?.ariaLabel?.(item),
      className: classes.btnAction,
      onClick: () => column?.cellAction?.callback(item)
    }, item?.[column?.id], column.cellAction?.icon && /*#__PURE__*/_react.default.createElement("span", {
      style: {
        marginLeft: 4
      }
    }, column.cellAction?.icon())) : item?.[column?.id]);
  })))), showPagination && /*#__PURE__*/_react.default.createElement(_core.TableFooter, null, /*#__PURE__*/_react.default.createElement(_core.TableRow, null, /*#__PURE__*/_react.default.createElement(_core.TablePagination, {
    rowsPerPageOptions: [10, 50, 100],
    colSpan: hasCheckbox ? computedHeaders.length + 1 : computedHeaders.length,
    count: tableMetadata.count,
    rowsPerPage: tableMetadata.rowsPerPage,
    page: tableMetadata.page,
    onPageChange: paginationPageChangeHandler,
    onRowsPerPageChange: rowsPerPageChangeHandler,
    labelDisplayedRows: _ref => {
      let {
        from,
        to,
        count
      } = _ref;
      return `${from}-${to} de ${count}`;
    },
    labelRowsPerPage: "Linhas por p\xE1gina",
    backIconButtonText: "P\xE1gina anterior",
    nextIconButtonText: "Pr\xF3xima p\xE1gina"
  })))));
};
exports.Table = Table;
Table.propTypes = {
  /** Dados iniciais da tabela no formato
   *
   * ```js
   * {
   *  data: Item[],
   *  count?: number,
   *  keyName?: string
   * }
   * ```
   */
  initialData: _propTypes.default.shape({
    /** Lista de objetos que deve ser usado para desenhar as tabelas */
    data: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
    /** Contagem para serem exibido nos totais e na paginação */
    count: _propTypes.default.number,
    /** nome da chave principal dos objetos da lista,
     * usado para adicionar os marcados e diferenciações internas, valor default
     * é 'id' */
    keyName: _propTypes.default.string
  }).isRequired,
  /**
   * Formatos das colunas
   *
   * ```js
   * {
   *   headers: {
   *     label: string,
   *     allowSorting?: boolean,
   *     columnWidth?: '1fr' | '#px' | '#%',
   *     comparatorFn?: {
   *       asc: (a, b) => number,
   *       desc: (a, b) => number,
   *     },
   *     cellAction?: {
   *       callback: (item) => void,
   *       ariaLabel: (item) => string,
   *       icon: () => React.FC,
   *     },
   *     headerAlign: 'center' | 'justify' | 'left' | 'right',
   *     bodyAlign: 'center' | 'justify' | 'left' | 'right',
   *   }
   * }
   * ```
   */
  columns: _propTypes.default.shape({
    /** definição dos cabeçãlhos */
    headers: _propTypes.default.objectOf(_propTypes.default.shape({
      /** O nome que aparecerá no cabeçalho */
      label: _propTypes.default.string.isRequired,
      /** indica que a coluna vai permitir ordenação */
      allowSorting: _propTypes.default.bool,
      /** usada para indicar qual a largura da coluna */
      columnWidth: _propTypes.default.string,
      /** usada quando necessário de uma ordenação customizada */
      comparatorFn: _propTypes.default.exact({
        asc: _propTypes.default.func.isRequired,
        desc: _propTypes.default.func.isRequired
      }),
      /** usado para configurar uma ação na célula */
      cellAction: _propTypes.default.shape({
        /** a ação que aconteceu ao clicar na célula */
        callback: _propTypes.default.func,
        /** callback para gerar o texto que ficará vinculado ao botão para leitores de tela */
        ariaLabel: _propTypes.default.func,
        /** usado quando a ação da célula necessitar de um icone */
        icon: _propTypes.default.func
      }),
      /** permite alinhar o cabelho da coluna */
      headerAlign: _propTypes.default.oneOf(['center', 'justify', 'left', 'right']),
      /** permite alinhar o conteudo da coluna */
      bodyAlign: _propTypes.default.oneOf(['center', 'justify', 'left', 'right'])
    })),
    /** Usada para controlar a exibição e funcionalidades do checkbox
     *
     */
    checkbox: _propTypes.default.shape({
      /** indica se deve exibir checkboxes no header e nas linhas */
      show: _propTypes.default.bool,
      /** usada para desabilitar o checkbox do header */
      disableAll: _propTypes.default.bool,
      /** callback que sera evocada ao acontecer uma mudança no estado dos checkbox */
      onChangeCallback: _propTypes.default.func
    })
  }).isRequired,
  /** Usado para gerar uma tabela com formato customizado */
  rowTemplate: _propTypes.default.func,
  /** Usada para controlar a paginação */
  pagination: _propTypes.default.shape({
    /** usado para indicar se deve ou não exibir paginção  */
    show: _propTypes.default.bool,
    /** callback que será evocada quando ocorrer um evento de mudança em paginação
     * ou per page
     */
    callback: _propTypes.default.func
  }),
  /** configurações de acessibilidade */
  a11yOptions: _propTypes.default.shape({
    /** Texto da tabela para leitores de tela */
    tableCaption: _propTypes.default.string,
    /** Texto do checkbox do header para leitores de tela */
    checkAllLabel: _propTypes.default.string,
    /** Função para gerar o texto de do checkbox das linhas para leitores de tela */
    checkSingleItemLabel: _propTypes.default.func
  })
};
Table.defaultProps = {
  rowTemplate: undefined,
  pagination: undefined,
  a11yOptions: undefined
};